var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17606 10.8896V17.6835C6.17606 18.0248 5.89961 18.3012 5.55836 18.3012H0.617694C0.276444 18.3012 0 18.0248 0 17.6835V9.65439C0 8.29021 1.10578 7.18353 2.47086 7.18353H11.7354C12.7584 7.18353 13.5885 8.01368 13.5885 9.03661C13.5885 10.0604 12.7584 10.8897 11.7354 10.8897L6.17606 10.8896ZM2.7791 5.63961C1.41492 5.63961 0.308238 4.53383 0.308238 3.16875C0.308238 1.80457 1.41483 0.69873 2.7791 0.69873C4.1441 0.69873 5.24996 1.80451 5.24996 3.16875C5.24996 4.53375 4.14418 5.63961 2.7791 5.63961ZM7.41149 2.24265C7.07024 2.24265 6.79379 1.96621 6.79379 1.62496C6.79379 1.28371 7.07024 1.00726 7.41149 1.00726H19.1469C20.1707 1.00726 21 1.83659 21 2.86034V12.1249C21 13.1487 20.1707 13.978 19.1469 13.978H12.9708C12.6296 13.978 12.3531 13.7016 12.3531 13.3603C12.3531 13.0191 12.6296 12.7426 12.9708 12.7426H19.1469C19.4882 12.7426 19.7646 12.4662 19.7646 12.1249V2.86034C19.7646 2.51909 19.4882 2.24265 19.1469 2.24265H7.41149Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.255aecc38e9daf85a9f12fb9ef1a5c56.svg";
export { ForwardRef as ReactComponent };